import React, { useEffect} from 'react';
import { HashLink } from 'react-router-hash-link';
import "./style.scss";

const TabletHeader = () => {
    const [navbar, setNavar] = React.useState(false);

    const changeBackground = () => {
        if(window.scrollY >= 100) {
          setNavar(true);
        } else {
          setNavar(false);
        }
  
      };

    useEffect(() => {
      window.addEventListener("scroll", changeBackground);

    })

    return (
        <header>
            {navbar ? (
                <nav className="tablet-title-header active">
                    <div className="tablet-title-cn" to="/#top">
                        <a href="/">
                            <img src="logo192.png" />
                        </a>
                    </div>
                    <ol className="list-cn">
                        <li className="list">
                            <HashLink smooth to="/#02">바른정플란트치과</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#03">의료진 소개</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#04">진료과목</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#05">바른정의 특별함</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#06">바른정 안내</HashLink>
                        </li>
                    </ol>
                </nav>
            ): (
                <nav className="tablet-title-header">
                    <div className="tablet-title-cn">
                        <a href="/">
                            <img src="logo192.png" />
                        </a>
                    </div>
                    <ol className="list-cn">
                        <li className="list">
                            <HashLink smooth to="/#02">바른정플란트치과</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#03">의료진 소개</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#04">진료과목</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#05">바른정의 특별함</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#06">바른정 안내</HashLink>
                        </li>
                    </ol>
                </nav>
            )}
            
        </header>
    );
};

export default TabletHeader;